module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid card-desktop"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-desktop-side"
  }, [_c('desktop-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "card-desktop-main"
  }, [_c('div', {
    staticClass: "card crd-header"
  }, [_c('desktop-header')], 1), _vm._v(" "), _c('div', {
    staticClass: "card card-desktop-body"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "container-x"
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin-top": "0.29em",
      "margin-left": "-0.8em",
      "color": "#000000"
    }
  }, [_c('ul', _vm._l((_vm.set_categories), function(data, index) {
    return _c('li', [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('a', {
      staticClass: "card-link"
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      style: ({
        'background-image': 'linear-gradient(to bottom, rgba(17, 17, 17, 0.097), rgba(8, 8, 8, 0.011)), url(' + data.category_image + ')'
      })
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(data.category_name))])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "-2em"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return ((index < 4) && (product.product_images && (product.product_images.length > 0))) ? _c('li', {
      staticClass: "col-xs-2",
      staticStyle: {
        "display": "inline",
        "padding": "0.5em",
        "border": "#000000 solid 0px"
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "height": "82px",
        "border-radius": "8px",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      style: ({
        'background-image': 'url(' + product.product_images[0].product_image + ')'
      })
    }), _vm._v(" "), _c('h6', {
      staticStyle: {
        "margin-top": "5px",
        "text-align": "left",
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(product.product_business_ownername))])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin": "0.2em",
      "margin-left": "-1.02em",
      "margin-top": "1em",
      "background": "#ffffff"
    }
  }, [_c('ul', {
    staticStyle: {
      "padding": "0"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return ((product.product_images && (product.product_images.length > 0))) ? _c('li', {
      staticStyle: {
        "width": "45%"
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "height": "108px",
        "border-radius": "8px",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      style: ({
        'background-image': 'url(' + product.product_images[0].product_image + ')'
      })
    }), _vm._v(" "), _c('h6', {
      staticStyle: {
        "margin-top": "5px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(product.product_business_ownername))])])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "1em",
      "margin-bottom": "2em"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, _vm._l((_vm.businesses), function(business, index) {
    return (index < 3) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "background-color": "#ffffff",
        "border": "#eee solid 1px",
        "border-radius": "8px",
        "padding": "0.2em 0.6em"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticStyle: {
        "width": "85%",
        "float": "left"
      }
    }, [_c('h4', {
      staticStyle: {
        "font-weight": "bolder",
        "font-size": "16px",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(business.business_name))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px",
        "line-height": "0.6"
      }
    }, [_vm._v("Location @ Business Name")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "15%",
        "float": "right",
        "margin-top": "10px"
      }
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "width": "30px",
        "height": "30px",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      style: ({
        'background-image': 'linear-gradient(to bottom, rgba(17, 17, 17, 0.097), rgba(8, 8, 8, 0.011)), url(' + _vm.banner_ad_image + ')'
      })
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })]), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
      return ((index < 3) && (product.product_images && (product.product_images.length > 0))) ? _c('div', {
        staticClass: "card",
        staticStyle: {
          "padding-top": "0.5em"
        }
      }, [_c('div', {
        staticClass: "col-xs-2 card-avatar-circle",
        staticStyle: {
          "width": "45px",
          "height": "45px",
          "background-repeat": "no-repeat",
          "background-size": "cover"
        },
        style: ({
          'background-image': 'url(' + product.product_images[0].product_image + ')'
        })
      }), _vm._v(" "), _c('div', {
        staticClass: "col-xs-9"
      }, [_c('h4', {
        staticStyle: {
          "margin-top": "0px",
          "text-align": "left",
          "white-space": "nowrap",
          "overflow": "hidden",
          "text-overflow": "ellipsis"
        }
      }, [_c('span', {
        staticStyle: {
          "font-weight": "bolder"
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', {
        staticStyle: {
          "font-size": "12px",
          "line-height": "0.6"
        }
      }, [_c('span', [_vm._v("@" + _vm._s(product.product_business_ownername))])]), _vm._v(" "), _c('hr', {
        staticStyle: {
          "margin": "8px"
        }
      })])]) : _vm._e()
    }), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })], 2)]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "height": "135px",
      "border-radius": "1px",
      "background": "#740215",
      "padding": "0.4em 2em"
    },
    style: ({
      'background-image': 'linear-gradient(to bottom, rgba(17, 17, 17, 0.397), rgba(8, 8, 8, 0.311)), url(' + _vm.banner_ad_image + ')'
    })
  }, [_c('h3', {
    staticStyle: {
      "background-color": "#f7d413",
      "padding": "0.3em",
      "padding-left": "1.62em",
      "margin-left": "-1.6em"
    }
  }, [_vm._v("Meal Timetable")]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return ((index < 9) && (product.product_images && (product.product_images.length > 0))) ? _c('div', {
      staticClass: "card col-xs-12",
      staticStyle: {
        "padding": "0.5em"
      }
    }, [_c('div', {
      staticClass: "col-xs-2",
      staticStyle: {
        "height": "52px",
        "border-radius": "8px",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      style: ({
        'background-image': 'url(' + product.product_images[0].product_image + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7"
    }, [_c('h4', {
      staticStyle: {
        "margin-top": "5px",
        "text-align": "left",
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("@" + _vm._s(product.product_business_ownername))])])]), _vm._v(" "), _vm._m(6, true)]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "background-color": "#fa0e06",
      "background-size": "contain",
      "border-radius": "4px",
      "padding": "0.5em"
    },
    style: ({
      'background-image': 'linear-gradient(to bottom, rgba(238, 9, 9, 0.897), rgba(247, 11, 11, 0.711)), url(' + _vm.banner_ad_image + ')'
    })
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border": "none",
      "margin": "0em",
      "margin-left": "-1.0em",
      "margin-top": "0em"
    }
  }, [_c('ul', {
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return ((product.product_images && (product.product_images.length > 0))) ? _c('li', {
      staticStyle: {
        "width": "30%",
        "background-color": "#ffffff",
        "border-radius": "14px"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "height": "102px",
        "border-radius": "5px",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      style: ({
        'background-image': 'url(' + product.product_images[0].product_image + ')'
      })
    }, [_vm._m(8, true)]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('h3', {
      staticStyle: {
        "margin-top": "5px",
        "text-align": "left",
        "white-space": "nowrap",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('h6', {
      staticStyle: {
        "line-height": "0.3"
      }
    }, [_c('i', {
      staticClass: "fas fa-map-marker"
    }), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(product.product_business_ownername))])]), _vm._v(" "), _vm._m(9, true), _vm._v(" "), _vm._m(10, true)])])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', {
    staticStyle: {
      "float": "left",
      "margin-left": "4px",
      "font-weight": "bolder",
      "font-size": "16px"
    }
  }, [_vm._v("Your Order List")]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("See all "), _c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "font-weight": "bolder"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', {
    staticStyle: {
      "float": "left",
      "margin-left": "4px",
      "font-weight": "bolder",
      "font-size": "16px"
    }
  }, [_vm._v("Favorite Places")]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("See all "), _c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "font-weight": "bolder"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', {
    staticStyle: {
      "float": "left",
      "margin-left": "4px",
      "font-weight": "bolder",
      "font-size": "16px"
    }
  }, [_c('i', {
    staticClass: "fas fa-map-marker",
    staticStyle: {
      "font-weight": "bolder",
      "color": "#740215"
    }
  }), _vm._v(" Near Me___\r\n                                    "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "line-height": "0.6"
    }
  }, [_vm._v("Location")])]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("See all "), _c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "font-weight": "bolder"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('h5', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("See all "), _c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "font-weight": "bolder"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "1em",
      "color": "#ffffff"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02-lt"
  }, [_vm._v("Exclusive for premium members "), _c('i', {
    staticClass: "fas fa-angle-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', {
    staticStyle: {
      "float": "left",
      "margin-left": "4px",
      "font-weight": "bolder",
      "font-size": "14px"
    }
  }, [_vm._v("Incredibly satisfying reviews")]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("See all "), _c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "font-weight": "bolder"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 mp0"
  }, [_c('p', {
    staticClass: "rate",
    staticStyle: {
      "line-height": "0.3",
      "margin-top": "0.6em"
    }
  }, [_c('i', {
    staticClass: "fas fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-star"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticStyle: {
      "float": "left",
      "margin-left": "4px",
      "color": "#f7f7f7"
    }
  }, [_vm._v("Ring your Orders "), _c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "color": "#ffffff"
    }
  }, [_vm._v("🔥 Hot")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "margin-left": "-5px",
      "background-color": "#f7d413",
      "padding": "3px 10px",
      "border-radius": "18px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("HO1 ITEM")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', {
    staticStyle: {
      "line-height": "0.3"
    }
  }, [_c('i', {
    staticClass: "fas fa-clock"
  }), _vm._v(" "), _c('span', [_vm._v("20 mins approx")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "-0.2em"
    }
  }, [_c('div', {
    staticClass: "rate",
    staticStyle: {
      "float": "left",
      "line-height": "0.3"
    }
  }, [_c('i', {
    staticClass: "fas fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-star"
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-star"
  }), _vm._v("\r\n                                    (46)\r\n                                    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-0.66em"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "border-radius": "50%",
      "padding": "0.3em 0.5em",
      "background-color": "#fa0e06",
      "color": "#ffffff"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1710ea3b"}!./src/pages/Timeline/desktop/desktop.html
// module id = 535
// module chunks = 0